import React, {
  useEffect,
  useState,
} from "react";

import {
  onAuthStateChanged,
} from "firebase/auth";

import {
  Navigate,
} from "react-router-dom";

import { auth } from "../../firebase";

export default function RequirePortalAuth({
  children,
}) {
  const [user, setUser] = useState(null);
  const [checkingAuth, setCheckingAuth] =
    useState(true);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(
      auth,
      (firebaseUser) => {
        setUser(firebaseUser);
        setCheckingAuth(false);
      }
    );

    return () => unsubscribe();
  }, []);

  if (checkingAuth) {
    return (
      <div
        style={{
          minHeight: "60vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        Loading portal...
      </div>
    );
  }

  if (
    !user ||
    user.email?.toLowerCase() !==
      "verizon@portal.gofoton.com"
  ) {
    return (
      <Navigate
        to="/login?mode=client"
        replace
      />
    );
  }

  const portalClient = {
    uid: user.uid,
    id: "verizon",
    name: "Verizon",
    authenticated: true,
  };

  return React.cloneElement(children, {
    portalClient,
  });
}